<div class="box-list">
  <ul class="list-flat">
    <li class="item"
      *ngFor="let item of list"
      [ngStyle]="{
        'width': itemWidth + '%',
        'height': itemHeight + '%'
      }"
      [ngClass]="{
        'left': item.isBorderLeft(),
        'top': item.isBorderTop(),
        'first-row': item.isFirstRow(),
        'last-row': item.isLastRow(),
        'first-column': item.isFirstColumn(),
        'last-column': item.isLastColumn()
      }">
      <a class="link" [href]="item.getLink()" target="_blank"
        (click)="linkClicked(item)">
        <div class="wrap">
          <div class="box-icon">
            <img class="img" [src]="item.getSrc()">
          </div>
          <div class="box-desc">
            <div class="desc">{{item.getDesc()}}</div>
          </div>
        </div>
      </a>
    </li>
  </ul>
</div>
